import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ReactComponent as FrydaLogo } from "./../../assets/logo/Fryda_logo.svg";
import { auth } from "../../firebase";

const AccessDenied = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { t } = useTranslation(); // Keep hook if translation needed later
    const navigate = useNavigate();

    const handleBack = async () => {
        try {
            await auth.signOut();
        } catch (error) {
            console.error("Error signing out:", error);
        }
        navigate('/');
    };

    return (
        <div className="min-h-screen bg-gradient-to-r from-[#E1E3F9] from-10% via-[#CDD1FF] via-30% to-[#E6EFFD] to-90% flex items-center justify-center">
            <div className="flex items-center justify-center flex-col max-w-md text-center px-4">
                <FrydaLogo className="mb-8" />
                <div className="bg-white p-8 rounded-lg shadow-2xl border-2 border-gray-600 w-full">
                    <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>
                    <p className="text-gray-700 mb-6">
                        You do not have permission to access this partner environment.
                        Please ensure you are logging into the correct environment or contact your administrator.
                    </p>
                    <button
                        onClick={handleBack}
                        className="bg-black text-white px-6 py-3 rounded-md hover:bg-gray-800 transition-colors w-full"
                    >
                        Back to Environment Search
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AccessDenied;
